import { FBPage } from 'components/FbUI/Page/FBPage'
import { Outlet, useLocation } from 'react-router-dom'
import {
  FBPageHeader,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'

import styled from 'styled-components'
import { useMemo } from 'react'

const GROUP_TITLES: Record<string, string> = {
  company: 'Company',
  users: 'Users',
  platform: 'Platform',
  data: 'Data',
  notifications: 'Notifications',
  misc: 'Misc Settings',
  automations: 'Automations',
  campaigns: 'Campaigns',
}

export function SettingsLayout() {
  const location = useLocation()

  const groupTitle = useMemo(() => {
    const segments = location.pathname.split('/')
    const group = segments[2] ?? 'users'
    return GROUP_TITLES[group] ?? 'Users'
  }, [location.pathname])

  return (
    <FBPage innerPageClassName="h-full">
      <CustomFBPageHeader>
        <FBPageTitleRow>
          <CustomFBPageTitle>
            Settings: <TabTitle>{groupTitle}</TabTitle>
          </CustomFBPageTitle>
        </FBPageTitleRow>
      </CustomFBPageHeader>

      <div className="flex gap-0 flex-1 min-h-0">
        <Outlet />
      </div>
    </FBPage>
  )
}

const CustomFBPageHeader = styled(FBPageHeader)`
  padding: 12px 0;
`

const CustomFBPageTitle = styled(FBPageTitle)`
  font-weight: 400;
  font-size: 24px;
`

const TabTitle = styled.span`
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  color: #101828;
  font-size: 24px;
`
